import { render, staticRenderFns } from "./AssignTasks.vue?vue&type=template&id=d3544344&scoped=true"
import script from "./AssignTasks.vue?vue&type=script&lang=js"
export * from "./AssignTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3544344",
  null
  
)

export default component.exports